// Recovered compiled webpack factory 68745. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { L: () => o, m: () => r });
  var n = i(33152),
    s = i(17727);
  function r(t, e) {
    return (0, n.FY)((0, n.bS)(t.getBoundingClientRect(), e));
  }
  function o(t, e, i) {
    let n = r(t, i),
      { scroll: o } = e;
    return (o && ((0, s.Ql)(n.x, o.offset.x), (0, s.Ql)(n.y, o.offset.y)), n);
  }
}
